import { create, type StateCreator } from 'zustand';
import { persist, type PersistOptions } from 'zustand/middleware';

export interface VendorStore {
  vendorId: number;

  setVendorId: (id: number) => void;
}

type VendorPersist = (
  config: StateCreator<VendorStore>,
  options: PersistOptions<VendorStore>
) => StateCreator<VendorStore>;

export const useVendorStore = create<VendorStore, []>(
  (persist as VendorPersist)(
    (set): VendorStore => ({
      vendorId: 0,

      setVendorId: (id: number) => {
        set(() => ({ vendorId: id }));
      },
    }),
    {
      name: 'vendor-store',
    }
  )
);

export const selectVendorId = (state: VendorStore) => state.vendorId;

export const selectSetVendorId = (state: VendorStore) => state.setVendorId;
